import {
  authenticationContext,
  cmxConfiguaration,
  cmxURL,
  navigation
} from '@codametrix/ui-common';

const STORAGE_CLEANUP = 2 * 60 * 1000;

const config = cmxConfiguaration.default;

const isExempted = (location: string) => {
  const partials = config.authenticationContext.partialUrls.some(
    exempted => location.includes(exempted)
  );
  if (partials) {
    return true;
  }
  return config.authenticationContext.exactUrls.some(
    // eslint-disable-next-line eqeqeq
    exempted => location == exempted
  );
};

const cleanUpStorage = () => {
  globalThis.sessionStorage.removeItem('jumpURL');
  globalThis.sessionStorage.removeItem('contextId');
  if (_cleanupStorageTimeout) {
    clearTimeout(_cleanupStorageTimeout);
    _cleanupStorageTimeout = null;
  }
};

let _cleanupStorageTimeout: NodeJS.Timeout | null = null;

export const saveJump = () => {
  const currentURL = new URL(`${globalThis?.top?.location}`);
  const exempt = isExempted(currentURL.pathname);

  if (!exempt) {
    if (navigation.isReload(globalThis)) {
      globalThis.sessionStorage.setItem('jumpURL', cmxURL.pathBuilder(currentURL));
    }
    // someone may have encountered the page as an already
    // logged in users or they may be accessing it as a link
    // without a primed session.
    const authorization = authenticationContext.getAuthorization();
    if (authorization.contextId !== null) {
      globalThis.sessionStorage.setItem('contextId', `${authorization.contextId}`);
    }
    // only populate sessionStorage for a limite period of time.
    // if someone doesn't log in within two minutes
    _cleanupStorageTimeout = setTimeout(cleanUpStorage, STORAGE_CLEANUP);
  }
};

export const getJump = () => {
  // this function is destructive. you only have one chance to jump.
  const jumpURL = globalThis.sessionStorage.getItem('jumpURL') || false;
  const jumpContext = globalThis.sessionStorage.getItem('contextId');
  const hasContext = jumpContext !== null;

  cleanUpStorage();
  return {
    url: jumpURL,
    hasContext,
    contextId: Number.parseInt(jumpContext ?? '0', 10)
  };
};

// this is really a private function and should not be exposed.
// it is only being exposed here for testing purposes.
export const _handleUnload = (event: Event) => {
  // auth token needs to be present for page refresh.
  const authorization = authenticationContext.getAuthorization();
  if (authorization.token) {
    globalThis.sessionStorage.setItem('authToken', `${authorization.token}`);
  }
  saveJump();
};

globalThis.addEventListener('unload', _handleUnload);
